import { HasSocketEvent, Validateable } from "@models/interfaces";

import { Time } from "./time";
import { ContactField } from "./contact_field";
import { SocketEvent } from "@helpers/types";

export class Contact extends Validateable implements HasSocketEvent {
	private name: string = "";
	private is_user: boolean = false;
	private last_used: Time = new Time();
	private deleted: boolean = false;
	private fields: ContactField[] = [new ContactField("email")];
	private _monogram: string = "";

	public eventData: SocketEvent = "";

	public getEvent(): string {
		return this.eventData;
	}

	public getPlainFields(): ContactField[] {
		return this.fields;
	}

	public getFields(deleted: boolean = false, includeEmail: boolean = true): ContactField[] {
		return (
			this.fields.filter((cf) => cf.isDeleted() === deleted && (includeEmail || cf.getType() !== "email")) || []
		);
	}

	public getFieldsForRecent(includeEmail: boolean = true): ContactField[] {
		return this.fields.filter((cf) => includeEmail || cf.getType() !== "email") || [];
	}

	public addField(field: ContactField): void {
		this.fields.push(field);
	}

	public getType(type: string): ContactField {
		return this.fields.find((f) => f.getType() === type);
	}

	public get _name(): string {
		return this.name;
	}

	public set _name(s: string) {
		this.setName(s);
	}

	public get _email(): string {
		let email = this.fields.find((cf) => cf.getType() === "email" && !cf.isDeleted());

		if (!email) {
			email = new ContactField("email");
			this.fields.push(email);
		}

		return email.getValue();
	}

	public set _email(s: string) {
		const email = this.fields.find((cf) => cf.getType() === "email" && !cf.isDeleted());

		if (email) {
			email.setValue(s);
		}
	}

	public getEmail(): string {
		return this._email;
	}

	public setName(n: string): void {
		this.name = n;
	}

	public getName(): string {
		return this.name;
	}

	public getLastUsed(): Time {
		return this.last_used;
	}

	public isUser(): boolean {
		return this.is_user;
	}

	public hasData(data: string): boolean {
		return this.getFields().some((f) => f.getValue().indexOf(data) >= 0);
	}

	public isDeleted(): boolean {
		return this.deleted;
	}

	public setFields(cfs: ContactField[]): void {
		const currentEmail = this.fields.find(
			(cf) => cf.getType() === "email" && cf.getValue() !== "" && !cf.isDeleted()
		);

		if (currentEmail) {
			// If the contact has an email address we can't overwrite it.
			this.fields = cfs.map((cf) => (cf.getType() === "email" ? currentEmail : cf));
		}

		this.fields = cfs;
	}

	public getMonogram(): string {
		if (this._monogram.length === 0) {
			// Is only called in views and will set the monogram on first call. Contacts NEED to have at least 2 characters to exist.
			this.setMonogram();
		}
		return this._monogram;
	}

	public setMonogram(): void {
		this._monogram = this.name.length ? this.name[0].toUpperCase() : "-";
	}
}
